import PolicyLayout from "@/components/PolicyLayout";

const sections = [
    {
        heading: "1. Who we are",
        body: [
            "Nexus Peptides (\"Nexus\", \"we\", \"our\", \"us\") is the data controller of any personal information you submit to nexuspeptides.online. We can be reached at info@nexuspeptides.online.",
        ],
    },
    {
        heading: "2. Information we collect",
        body: ["When you interact with our site we may collect:"],
        list: [
            "Account data — name and email address you provide when registering.",
            "Order data — shipping address, phone number, items ordered, and the last four digits of the payment card used.",
            "Contact form data — the name, email, subject, and message you submit.",
            "Technical data — IP address, browser type, device identifiers, pages visited, and session identifiers.",
        ],
    },
    {
        heading: "3. How we use your information",
        body: ["We process personal data for the following purposes and legal bases:"],
        list: [
            "To process and ship your orders (performance of a contract).",
            "To respond to your enquiries (legitimate interest).",
            "To verify researcher status and prevent fraud (legitimate interest, legal obligation).",
            "To send service emails about your order (performance of a contract).",
            "To improve site performance and security (legitimate interest).",
            "To comply with legal, accounting, and regulatory obligations.",
        ],
    },
    {
        heading: "4. Sharing your data",
        body: [
            "We share personal data only with service providers who help us deliver the service — for example payment processors, shipping carriers, and email providers. All third parties are contractually required to handle your data in line with this policy and applicable law.",
            "We may disclose data to law enforcement or regulators where we are legally required to do so.",
        ],
    },
    {
        heading: "5. International transfers",
        body: [
            "Where personal data is transferred outside your home jurisdiction we use appropriate safeguards such as Standard Contractual Clauses or equivalent measures.",
        ],
    },
    {
        heading: "6. Data retention",
        body: [
            "Account and order data is retained for as long as your account is active and for up to seven years thereafter to satisfy tax and accounting requirements. Contact form submissions are retained for up to two years. Technical logs are retained for up to 90 days.",
        ],
    },
    {
        heading: "7. Your rights",
        body: ["Depending on your location you may have the following rights:"],
        list: [
            "Access — request a copy of the personal data we hold about you.",
            "Rectification — ask us to correct inaccurate data.",
            "Erasure — ask us to delete your data where there is no legal basis to retain it.",
            "Restriction and objection — ask us to limit how we process your data.",
            "Portability — receive a machine-readable copy of data you provided to us.",
            "Withdraw consent — where processing is based on consent, you may withdraw it at any time.",
            "Lodge a complaint with the supervisory authority in your country.",
        ],
    },
    {
        heading: "8. Security",
        body: [
            "We use industry-standard technical and organisational measures to protect your data, including TLS encryption in transit, bcrypt-hashed passwords, and access controls on internal systems. No method of transmission over the internet is 100% secure; we cannot guarantee absolute security.",
        ],
    },
    {
        heading: "9. Children",
        body: [
            "Our products and services are intended for adult researchers only. We do not knowingly collect personal data from anyone under the age of 18. If you believe a minor has provided us with personal data, please contact us and we will delete it.",
        ],
    },
    {
        heading: "10. Changes to this policy",
        body: [
            "We may update this policy from time to time. Material changes will be communicated by updating the date at the top of this page and, where appropriate, notifying registered users by email.",
        ],
    },
    {
        heading: "11. Contact",
        body: [
            "Questions or requests about your personal data may be sent to info@nexuspeptides.online.",
        ],
    },
    {
        heading: "12. Company details",
        body: [
            "Coresight Creative Limited",
            "128 City Road, London, United Kingdom, EC1V 2NX",
            "Registered in England and Wales, company number 16828110",
            "Contact: info@nexuspeptides.online",
        ],
    },
];

export default function PrivacyPolicy() {
    return (
        <PolicyLayout
            eyebrow="// Legal"
            title="Privacy policy"
            intro="This policy explains what personal information we collect, why we collect it, and the choices you have about how it is used. By using nexuspeptides.online you confirm that you have read and understood this policy."
            sections={sections}
            footer="This document is provided for general information only and does not constitute legal advice. Please consult qualified legal counsel for advice on your specific situation."
        />
    );
}
